import React, { FC, useEffect, useRef, useState } from 'react';
import { MetaTagDropdown }                        from '../forms/dropdowns/MetaTagDropdown';
import { useFormikContext }                       from 'formik';

interface Props {
	omit?: string[],
	allowAdditions?: boolean,
	loading?: boolean,
	
	onChange?( value: string ): void,
}

const defaultProps: Props = {
	omit:           [],
	allowAdditions: false,
	loading:        false,
	
	onChange: ( value ) => {},
}

const MetaTagSearchInput: FC<Props> = ( props ) => {
	
	let [ searchQuery, setSearchQuery ] = useState( '' );
	
	let formik = useFormikContext();
	
	const handleOnChange = ( value ) => {
		
		props.onChange( value );
		
		clearCurrentValue()
	};
	
	const handleSearchChange = ( e, { searchQuery } ) => {
		
		setSearchQuery( searchQuery );
	};
	
	const handleAddition = ( e, { value } ) => {
		
		setSearchQuery( '' );
		
		props.onChange( value );
		
		clearCurrentValue()
	};
	
	const clearCurrentValue = () => {
		
		formik.setFieldValue( 'metaTagsInput', '' );
	}
	
	const allowAdditions = () => {
		
		return props.allowAdditions && !props.omit.includes( searchQuery );
	}
	
	return (
		
		<MetaTagDropdown
			search
			fluid
			selection
			clearable
			name={ 'metaTagsInput' }
			omit={ props.omit }
			loading={ props.loading }
			searchQuery={ searchQuery }
			selectOnNavigation={ false }
			selectOnBlur={ false }
			allowAdditions={ allowAdditions() }
			onAddItem={ handleAddition }
			onSearchChange={ handleSearchChange }
			onChange={ handleOnChange }
			closeOnChange={ false }
			placeholder={ 'Start typing to search...' }
			noResultsMessage={ `No tags found.${ allowAdditions() ? ' Type a label in to add one.' : '' }` }
		/>
	)
};

MetaTagSearchInput.defaultProps = defaultProps;

export { MetaTagSearchInput }
